// Mock data for PRINTLY portfolio website

export const kiosks = {
  images: [
    "https://customer-assets.emergentagent.com/job_instant-print-hub-3/artifacts/4p9te8q2_20260331_0058_Image%20Generation_simple_compose_01kn08k9yxes5v7f8dvbg8mtq6.png",
    "https://customer-assets.emergentagent.com/job_instant-print-hub-3/artifacts/zwalomc0_20260331_0058_Image%20Generation_simple_compose_01kn08k9yvf3aspbvpfwtx20y5.png",
    "https://customer-assets.emergentagent.com/job_instant-print-hub-3/artifacts/2mqlm5aj_ChatGPT%20Image%20Mar%2031%2C%202026%2C%2012_57_42%20AM.png"
  ]
};

export const environmentImages = {
  students: "https://images.pexels.com/photos/7683750/pexels-photo-7683750.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  library: "https://images.pexels.com/photos/31138996/pexels-photo-31138996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  office: "https://images.pexels.com/photos/36631699/pexels-photo-36631699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const features = [
  {
    title: "QR-Based Access",
    description: "Simply scan the QR code with your phone to start. No apps, no accounts needed.",
    icon: "qr-code"
  },
  {
    title: "Instant Printing",
    description: "Upload and print in seconds. Perfect for urgent documents and last-minute assignments.",
    icon: "zap"
  },
  {
    title: "Scheduled Printing",
    description: "Schedule your prints in advance and pick them up whenever convenient.",
    icon: "clock"
  },
  {
    title: "Secure Document Handling",
    description: "End-to-end encryption for your documents. Private prints with PIN protection and auto-delete after collection.",
    icon: "shield-check"
  },
  {
    title: "Easy Online Payment",
    description: "Secure digital payments with UPI, cards, and wallets. No cash hassles.",
    icon: "credit-card"
  },
  {
    title: "Multiple Format Support",
    description: "Supports A4 & A5 sizes. Print PDFs, documents, and images effortlessly.",
    icon: "file-text"
  },
  {
    title: "24/7 Availability",
    description: "Access PRINTLEY anytime, anywhere it's installed. Round-the-clock service.",
    icon: "clock-3"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Scan QR Code",
    description: "Use your phone camera to scan the QR code on the kiosk screen",
    icon: "scan"
  },
  {
    step: 2,
    title: "Upload Document",
    description: "Select your file from cloud storage or device. Supports PDF, DOCX, and images",
    icon: "upload"
  },
  {
    step: 3,
    title: "Choose Print Type",
    description: "Select Black & White or Color printing based on your needs",
    icon: "palette"
  },
  {
    step: 4,
    title: "Make Payment",
    description: "Pay securely through UPI, cards, or digital wallets",
    icon: "wallet"
  },
  {
    step: 5,
    title: "Print & Collect",
    description: "Get instant prints or schedule for later pickup",
    icon: "printer"
  }
];

export const useCases = [
  {
    title: "Colleges & Universities",
    description: "Perfect for students printing assignments, notes, and project reports",
    image: environmentImages.students,
    icon: "graduation-cap"
  },
  {
    title: "Schools",
    description: "Easy access for students and teachers to print educational materials",
    image: environmentImages.library,
    icon: "book-open"
  },
  {
    title: "Government Offices",
    description: "Efficient document printing for public services and official work",
    image: environmentImages.office,
    icon: "building"
  },
  {
    title: "Libraries",
    description: "Self-service printing for library members and researchers",
    image: environmentImages.library,
    icon: "library"
  },
  {
    title: "Co-working Spaces",
    description: "On-demand printing for freelancers and remote workers",
    image: environmentImages.office,
    icon: "users"
  },
  {
    title: "Corporate Offices",
    description: "Quick document printing for meetings and presentations",
    image: environmentImages.office,
    icon: "briefcase"
  }
];

export const faqs = [
  {
    question: "How does PRINTLEY work?",
    answer: "Simply scan the QR code on the kiosk, upload your document from your phone, select print options (B&W or Color), make payment, and collect your prints instantly."
  },
  {
    question: "Can I schedule prints for later?",
    answer: "Yes! PRINTLEY allows you to schedule prints in advance. Upload your document, pay online, and pick up your prints at your convenience."
  },
  {
    question: "What file types are supported?",
    answer: "PRINTLEY supports PDF, DOCX, JPG, PNG, and most common document and image formats."
  },
  {
    question: "How secure are my documents?",
    answer: "PRINTLEY uses end-to-end encryption for all document uploads. You can set a PIN for private prints, and all documents are automatically deleted from our servers immediately after printing."
  },
  {
    question: "How do I make payment?",
    answer: "We accept UPI, credit/debit cards, and popular digital wallets. All payments are secure and encrypted."
  },
  {
    question: "Is PRINTLEY available 24/7?",
    answer: "Yes, PRINTLEY kiosks are available round-the-clock wherever they're installed, giving you printing access anytime you need it."
  },
  {
    question: "What paper sizes do you support?",
    answer: "Currently, PRINTLEY supports A4 and A5 paper sizes for both black & white and color printing."
  },
  {
    question: "Do I need to install an app?",
    answer: "No app installation required! Just scan the QR code with your phone's camera to access the web-based interface."
  },
  {
    question: "How much does printing cost?",
    answer: "Pricing varies by location and print type. Rates are displayed on the kiosk screen before you confirm your print job."
  }
];

export const dashboardStats = {
  totalPrints: 15234,
  activeKiosks: 28,
  todayRevenue: 45678,
  weeklyGrowth: 23.5,
  recentActivity: [
    { location: "IIT Delhi - Library", prints: 342, time: "2 hours ago" },
    { location: "DU North Campus", prints: 289, time: "3 hours ago" },
    { location: "Tech Park Bangalore", prints: 456, time: "5 hours ago" },
    { location: "Anna University", prints: 198, time: "6 hours ago" }
  ]
};

export const contactInfo = {
  email: "hello@printley.in",
  phone: "+91 98765 43210",
  whatsapp: "+91 98765 43210"
};
